import { Timestamp } from "@smartsuite/automation-engine-api";
import { t } from "i18next";
import * as S from "./style";
import type { Author } from "@smartsuite/automation-engine-api";
import { useRootStore } from "../../../stores/hooks";
import type { UserPreferences } from "../../../types/user-preferences";
import {
  formatDateByUserPreferences,
  getTimeFormatByUserPreferences,
} from "../../../utils/date";
import type { AutomationCandidate } from "../../../types/candidate";

export const Details: React.FC<{
  automation: AutomationCandidate;
}> = ({ automation: { firstCreated, lastUpdated } }) => {
  const { config, automations } = useRootStore();
  const details = getDetails(
    config.userPreferences,
    automations.candidate.getTimezone(),
    firstCreated,
    lastUpdated,
  );
  return (
    details && (
      <S.Root>
        <S.Event>{details.prefix}</S.Event>{" "}
        <S.Text>
          {t("automation-details.by")}{" "}
          <span className="author">{details.author}</span>{" "}
          {t("automation-details.on")}{" "}
          <span className="date">{details.date}</span>{" "}
          {t("automation-details.at")} {details.time}
        </S.Text>
      </S.Root>
    )
  );
};

const getDetails = (
  userPreferences: UserPreferences,
  timezone: string,
  firstCreated?: Author,
  lastUpdated?: Author,
): {
  prefix: string;
  author: string;
  date: string;
  time: string;
} | null => {
  if (lastUpdated?.on) {
    const eventDate = Timestamp.toDate(lastUpdated.on);

    return {
      prefix: t("automation-details.last-updated"),
      author: lastUpdated.by,
      date: formatDateByUserPreferences(
        eventDate,
        timezone,
        userPreferences.locale.date_format,
      ),
      time: formatDateByUserPreferences(
        eventDate,
        timezone,
        getTimeFormatByUserPreferences(userPreferences),
      ),
    };
  } else if (firstCreated?.on) {
    const eventDate = Timestamp.toDate(firstCreated.on);

    return {
      prefix: t("automation-details.first-created"),
      author: firstCreated.by,
      date: formatDateByUserPreferences(
        eventDate,
        timezone,
        userPreferences.locale.date_format,
      ),
      time: formatDateByUserPreferences(
        eventDate,
        timezone,
        getTimeFormatByUserPreferences(userPreferences),
      ),
    };
  } else {
    return null;
  }
};
